module.exports = __webpack_public_path__ + "img/questions_bg.0a2f1717.png";